// Shared helper for a venue <select> backed by the venue -> bot ID mapping
// table. The select is a quick-pick convenience; the venue value itself
// always comes from (and can be typed directly into) a plain text input
// shown alongside it, so a venue not yet in the mapping table can still be
// entered freely.

export function isKnownVenue(venue: string, options: { venue: string }[]): boolean {
  return options.some((option) => option.venue === venue);
}
